import React, { useEffect, useState, useContext } from "react";
import GlobalContext from './../../contexts/GlobalContext';
import Utility from './../../Utility';
import { Message, Grid, Loader, Dimmer, Button } from 'semantic-ui-react';
import Page from './../../components/Page/Page';
import Box from './../../components/Box/Box';
import BookingsFolder from './../../components/Bookings/BookingFolder/BookingFolder';
import BookingLoader from './BookingLoader';
import API, { ResponseManagement, ErrorManagement } from './../../API';
//import Auth from './../../Auth';
import './bookings.css';
import {connect} from "react-redux";
//import {totalBookingFolderPrice} from "@store/booking";
//import ModalTransition from "@components/ModalTransition/ModalTransition";
//import {config} from "@src/Config";
//import {toast} from "react-toastify";

const mapProps = (state) => ({
  bookingFolderInvoices: state.invoices.selectedInvoices,
  selectedBookingFolderId: state.invoices.bookingFolderId,
  bookingFolderEstablishmentId: state.invoices.establishmentId,
  isModalHandleInvoicesOpen: state.modal.handleBookingFolderInvoices
})

const mapDispatch = (dispatch) => ({
  handleInvoicesModal: dispatch.modal.handleModal,
  loadInvoices: dispatch.invoices.load
})

const Bookings = props => {
  const [globalContext, dispatch] = useContext(GlobalContext);
  const [isLoading, setIsLoading] = useState(true);
  const [loader, setLoader] = useState(false);
  // const [bookings, setBookings] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [listeResa, setListeResa] = useState([]);
  const [listeResaActive, setListeResaActive] = useState([]);
  const [listeResaHisto, setListeResaHisto] = useState([]);
  const [haveBookingFuture, setHaveBookingFuture] = useState([]);
  const [displaySelect, setDisplaySelect] = useState('all');
  const [rating, setRating] = useState([]);
  const [nbStatus, setNbStatus] = useState({});

  const [btnListeActive, setBtnListeActive] = useState(true);
  const [btnListeHisto, setBtnListeHisto] = useState(false);

  const [btnActive, setBtnActive] = useState(false);
  const [btnFuture, setBtnFuture] = useState(false);
  const [btnPassed, setBtnPassed] = useState(false);
  const [btnCancel, setBtnCancel] = useState(false);

  let timeout = null;

  useEffect(() => {
    timeout = setTimeout(() => {
      setLoader(false);
    }, 100);
  }, [displaySelect])

  useEffect(() => {
    /*if(Auth.isAuthenticatedViaPassword() === false) {
      let datasAuth = Auth.getAuthViaURL();
      let paramsPage = Utility.getHeaderPage('bookings', globalContext.translations);
      if(datasAuth.codePage === paramsPage.codePage || datasAuth.codePage === 'bookingFolderInformations' ) {
        if(datasAuth.id !== '') {
          props.history.push(`/${props.match.params.token}/${props.match.params.lang}/bookings/${datasAuth.id}`);
        }
      } else {
        Auth.logout();
      }
    }*/
    dispatch({ type: 'SET_HEADERS', payload: Utility.getHeaderPage('bookings', globalContext.translations) });
    API.get(Utility.getUrlAjax() + '/bookingFolderListing').then(response => {
      ResponseManagement(response,
        () => {
          if (response.data.errors && Object.entries(response.data.errors).length > 0) {
            setErrorMsg(response.data.message);
          } else {
            response.data.data.bookingFolders.sort((a, b) => {
              // cancel en dernier
              if (a.state === 'cancel' && b.state !== 'cancel') {
                return 1
              }
              // passed avant dernier
              if (a.state === 'passed' && b.state !== 'passed' && b.state !== 'cancel') {
                return 1
              }
              // active en 2eme
              if (a.state !== 'active' && a.state !== 'pending' && b.state === 'active') {
                return 1
              }
              // pending en premier
              if (a.state !== 'pending' && b.state === 'pending') {
                return 1
              }
              return -1
            })
            setRating(response.data.data.ratings)
            //setListeResa(response.data.data.bookingFolders)
            setHaveBookingFuture(response.data.data.haveBookingFuture)

            /*setListeResaActive( response.data.data.bookingFolders.filter( (Folder) => Folder.state === 'active' ||
                                                                                      Folder.state === 'future' ) )*/
            let ResaActive = response.data.data.bookingFolders.filter( (Folder) => Folder.state === 'active'
                || Folder.state === 'future'
                || Folder.state === 'pending'
                || Folder.state === 'enOption' );
            setListeResaActive( ResaActive )

            let ResaHisto = response.data.data.bookingFolders.filter( (Folder) => Folder.state === 'passed' || Folder.state === 'cancel' )
            setListeResaHisto( ResaHisto )

            setListeResa(ResaActive)

            let nbFolder = {nbAllActive : 0,nbActive : 0,nbFuture : 0,nbAllHisto : 0,nbPassed : 0,nbCancel : 0}

            nbFolder.nbActive = response.data.data.bookingFolders.filter(Folder => Folder.state === 'active').length;
            nbFolder.nbPassed = response.data.data.bookingFolders.filter(Folder => Folder.state === 'passed').length;

            nbFolder.nbFuture = response.data.data.bookingFolders.filter(Folder => Folder.state === 'future' || Folder.state === 'pending').length;
            nbFolder.nbFuture += response.data.data.bookingFolders.filter(Folder => Folder.state === 'enOption').length;

            nbFolder.nbCancel = response.data.data.bookingFolders.filter(Folder => Folder.state === 'cancel').length;
            nbFolder.nbAllActive = ResaActive.length;
            nbFolder.nbAllHisto = ResaHisto.length;
            setNbStatus( nbFolder )

            // setInvoicesState(response.data.data.invoices);
            props.loadInvoices(response.data.data.invoices);
          }
          setIsLoading(false);
        },
        () => { }
      );
    }).catch(error => {
      console.error(error)
      ErrorManagement(error, () => { });
    })

    return () => {
      clearTimeout(timeout)
    }
  }, [])

  const handleChange = (event, el) => {
    setDisplaySelect(el.value);
    setLoader(true);
  }

  const toogleListeResa = (choix, e) => {
    //console.log(choix)
    if( choix == 'resa' || choix == 'active' || choix == 'future' ){
      setBtnListeActive(true)
      setBtnListeHisto(false)
      setBtnActive(false)
      setBtnFuture(false)
      setBtnPassed(false)
      setBtnCancel(false)
      if ( choix == 'active') { setBtnActive(true) }
      if ( choix == 'future') { setBtnFuture(true) }
      setListeResa( listeResaActive )
      if( choix != 'resa' ){ setDisplaySelect(choix) }
      else{ setDisplaySelect('all')  }
    }
    else if( choix == 'histo' || choix == 'passed' || choix == 'cancel' ){
      setBtnListeActive(false)
      setBtnListeHisto(true)
      setBtnActive(false)
      setBtnFuture(false)
      setBtnPassed(false)
      setBtnCancel(false)
      if ( choix == 'passed') { setBtnPassed(true) }
      if ( choix == 'cancel') { setBtnCancel(true) }
      setListeResa( listeResaHisto )
      if( choix != 'histo' ){ setDisplaySelect(choix) }
      else{ setDisplaySelect('all')  }
    }
  }

  useEffect(() => {
    timeout = setTimeout(() => {
      setLoader(false);
    }, 100);
  }, [displaySelect])

  const options = [
    { key: 'all', value: 'all', text: globalContext.translations.bookingsStatusAll + ' ('+nbStatus.nbAll+')' },
    { key: 'active', value: 'active', text: globalContext.translations.bookingsStatusActive + ' ('+nbStatus.nbActive+')' },
    { key: 'passed', value: 'passed', text: globalContext.translations.bookingsStatusPassed + ' ('+nbStatus.nbPassed+')' },
    { key: 'future', value: 'future', text: globalContext.translations.bookingsStatusFuture + ' ('+nbStatus.nbFuture+')' },
    { key: 'cancel', value: 'cancel', text: globalContext.translations.bookingsStatusCancel + ' ('+nbStatus.nbCancel+')' },
  ]

  return (
    <Page location={props.location} history={props.history}>
      {isLoading
        ? <BookingLoader />
        : <Box message={false} header="">
          <Dimmer active={loader} inverted>
            <Loader>{globalContext.translations.loading}</Loader>
          </Dimmer>
          {errorMsg === ''
            ? <Grid className="mt-4 skinnyRow" style={{ height: "100%" }} columns="equal">
                {/*<Grid.Row verticalAlign="middle" textAlign="right">
                  <Grid.Column only="computer" computer={12} >
                    <Header size="small">{globalContext.translations.bookingsDisplayParams}:</Header>
                  </Grid.Column>
                  <Grid.Column computer={4} mobile={16}>
                    <Dropdown
                      defaultValue={displaySelect}
                      selection
                      options={options}
                      onChange={handleChange}
                    />
                  </Grid.Column>
                </Grid.Row>*/}
                <Grid.Row verticalAlign="middle" >
                  <Grid.Column computer={16} mobile={16}>
                    <div className="two ui large buttons separeted">
                      <Button active={btnListeActive} onClick={ () => toogleListeResa('resa')}>
                        {globalContext.translations.bookings + ' ('+nbStatus.nbAllActive+')' }
                      </Button>
                      <div className="or"></div>
                      <Button active={btnListeHisto} onClick={ (e) => toogleListeResa('histo', e)} >
                        {globalContext.translations.history + ' ('+nbStatus.nbAllHisto+')'}
                      </Button>
                    </div>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row only="computer" verticalAlign="middle" >
                  <Grid.Column computer={16} mobile={8}>
                    <div className="four ui large buttons separeted">
                      {/* Active */}
                      <Button active={btnActive} onClick={ () => toogleListeResa('active')}>
                        {globalContext.translations.bookingsStatusActive + ' ('+nbStatus.nbActive+')'}
                      </Button>
                      <div className="or"></div>
                      {/* Future */}
                      <Button active={btnFuture} onClick={ () => toogleListeResa('future')} >
                        {globalContext.translations.bookingsStatusFuture + ' ('+nbStatus.nbFuture+')'}
                      </Button>
                      <div className="or"></div>
                      {/* Passed */}
                      <Button active={btnPassed} onClick={ () => toogleListeResa('passed')} >
                        {globalContext.translations.bookingsStatusPassed + ' ('+nbStatus.nbPassed+')'}
                      </Button>
                      <div className="or"></div>
                      {/* Cancel */}
                      <Button active={btnCancel} onClick={ () => toogleListeResa('cancel')} >
                        {globalContext.translations.bookingsStatusCancel + ' ('+nbStatus.nbCancel+')'}
                      </Button>
                    </div>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row only="tablet mobile" verticalAlign="middle" >
                  <Grid.Column computer={16}>
                    <div className="two ui large buttons separeted">
                      { btnListeActive ?
                        <>
                          {/* Active */}
                          <Button active={btnActive} onClick={ () => toogleListeResa('active')}>
                            {globalContext.translations.bookingsStatusActive + ' ('+nbStatus.nbActive+')'}
                          </Button>
                          <div className="or"></div>
                          {/* Future */}
                          <Button active={btnFuture} onClick={ () => toogleListeResa('future')} >
                            {globalContext.translations.bookingsStatusFuture + ' ('+nbStatus.nbFuture+')'}
                          </Button>
                        </>
                        :
                        <>
                          {/* Passed */}
                          <Button active={btnPassed} onClick={ () => toogleListeResa('passed')} >
                            {globalContext.translations.bookingsStatusPassed + ' ('+nbStatus.nbPassed+')'}
                          </Button>
                          <div className="or"></div>
                          {/* Cancel */}
                          <Button active={btnCancel} onClick={ () => toogleListeResa('cancel')} >
                            {globalContext.translations.bookingsStatusCancel + ' ('+nbStatus.nbCancel+')'}
                          </Button>
                        </>
                      }
                    </div>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column>
                    <BookingsFolder
                      haveBookingFuture={haveBookingFuture}
                      bookings={listeResa}
                      select={displaySelect}
                      rating={rating}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            : <Message negative>
                <Message.Header>Erreur</Message.Header>{/*TODO trad */}
                <p>{errorMsg}</p>
              </Message>
          }

        </Box>
      }
    </Page>
  )
}

export default connect(mapProps, mapDispatch)(Bookings);
